module.exports = __webpack_public_path__ + "static/media/menu.19e49578.png";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/assets/images/menu.png
// module id = 432
// module chunks = 27